import React from "react";

function SvgIcMapPoi003(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M18 20h-3v-3h3c1.208 0 1.482.825 1.5 1.5 0 .451-.147 1.5-1.5 1.5m0-6c3.302 0 4.5 2.691 4.5 4.5 0 1.809-1.198 4.5-4.5 4.5h-3v3h-3V14zm-1.419-7.814l7 5a1 1 0 11-1.162 1.627L16 8.229l-6.419 4.584a1 1 0 11-1.162-1.627l7-5a1 1 0 011.162 0z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi003;
